import React, { useContext, useEffect, useState } from "react";
import { Col, FloatButton, Row } from "antd";
import { getpatientMedicationsAPI } from "../../../services/patient.services";
import { useLocation } from "react-router-dom";
import AddMedicineModal from "./AddMedicineModal";
import ScanImageDrawer from "./ScanImage/ScanImageDrawer";
import MedicationHistoryChart from "./MedicationHistoryChart";
import AddMedicineTable from "./AddMedicineTable";
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import FloatingRecorder from "../AiAssistant/FloatingRecorder";
import RecordModal from "../AiAssistant/RecordModal";
import { UserContext } from "../../../context/UserContext";
import aiIcon from "../../../assets/dashboardIcons/aiIcon.svg";
import { getCookie } from "../../../helpers/localStorage";
import { Role } from "../../../constants/defaultKeys";
const MedicationHistoryIP = ({ patientData }) => {
  const location = useLocation();
  const { userDetails } = useContext(UserContext);
  const params = Object.fromEntries(new URLSearchParams(location?.search));
  const [open, setOpen] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [data, setData] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(true);
  const [historyModal, setHistoryModal] = useState(false);
  const [openAiModal, setOpenAiModal] = useState(false);
  const [showFloatingRecorder, setShowFloatingRecorder] = useState(false);
  const [aiResponse, setAiResponse] = useState(null);
  const userRole = userDetails?.currRole || getCookie(Role);
  const refreshPage = () => {
    setRefresh((prev) => !prev);
  };
  const handleProcessComplete = (responseData) => {
    setAiResponse(responseData);
    setShowFloatingRecorder(false);
    setOpenAiModal(true);
  };

  useEffect(() => {
    getpatientMedicationsAPI(`ip_admission=${params?.patient}`)
      .then((res) => {
        setData(res?.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  }, [refresh]);

  return (
    <>
      {loading ? (
        <LoadingIndicator message="Loading data, please wait" />
      ) : (
        <>
          <Row gutter={[12, 12]}>
            <Col span={24}>
              <AddMedicineTable
                data={data}
                setData={setData}
                refreshPage={refreshPage}
                loading={loading}
                setOpen={setOpen}
                setHistoryModal={setHistoryModal}
              />
            </Col>
          </Row>
        </>
      )}

      {open && (
        <ScanImageDrawer
          open={open}
          setOpen={setOpen}
          refreshPage={refreshPage}
        />
      )}
      {addModal && (
        <AddMedicineModal
          open={addModal}
          setOpen={setAddModal}
          refreshPage={refreshPage}
        />
      )}
      {historyModal && (
        <MedicationHistoryChart
          open={historyModal}
          setOpen={setHistoryModal}
          data={data}
          params={params}
          patientData={patientData?.admission}
        />
      )}
      {userRole === "Doctor" && (
        <FloatButton
          shape="circle"
          type="primary"
          className="ai-assistant-float"
          icon={<img src={aiIcon} alt="AI Icon" width={25} height={32} />}
          onClick={() => {
            setShowFloatingRecorder(true);
            // setShowTooltip(false);
          }}
        />
      )}
      {showFloatingRecorder && (
        <FloatingRecorder
          onProcessComplete={handleProcessComplete}
          onClose={() => {
            setShowFloatingRecorder(false);
          }}
          userDetails={userDetails}
        />
      )}

      {/* Modal with AI Response */}
      {openAiModal && aiResponse && (
        <RecordModal
          open={openAiModal}
          setOpen={setOpenAiModal}
          refreshPage={refreshPage}
          aiResponse={aiResponse}
          startInFormStep={true}
        />
      )}
    </>
  );
};

export default MedicationHistoryIP;
